module.exports = __webpack_public_path__ + "static/media/isol.9b660d89.png";